import { Alert, Box, Button } from "@mui/material";
import React from "react";
import { CurrencyDisplay } from "./CurrencyField";

export default function SubmitButton({
  isEditing,
  multipleSimulations,
  error,
  onCancel,
}: {
  isEditing: boolean | undefined;
  multipleSimulations?: boolean;
  error: string | null;
  onCancel: () => void;
}) {
  return (
    <>
      {error && (
        <Alert severity="error" sx={{ ml: 2 }}>
          <CurrencyDisplay message={error} decimalPlaces={2} />
        </Alert>
      )}
      <Box sx={{ display: "flex", gap: 2, alignItems: "center", mt: 3 }}>
        <Button type="submit" variant="contained" color="primary">
          {isEditing ? "Update" : "Create"} Simulation
          {multipleSimulations ? "s" : ""}
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
}
